<template>
  <div>
    <EquipmentEditHeader v-if="isAdmin" data-cy="equipment-edit-header" />
    <EquipmentTable
      data-cy="equipment-table"
      @select="$emit('select', $event.data)"
    />
  </div>
</template>

<script setup lang="ts">
import { useYTool } from "@/composables/equipment/yTool/yTool";
import { provide } from "vue";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { BaseEquipment } from "@/composables/equipment/equipmentTypes";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: BaseEquipment): void;
}>();

const yToolSearch = useYTool(props.isAdmin);

provide("equipment", yToolSearch);
</script>
